import React from "react";
import { AuthProvider } from "./context/AuthContexto";
import { ThemeProvider } from "./context/ThemeContexto";
import AppRouter from "./router/AppRouter";
import SessionExpiredModal from "./components/SessionExpiredModal";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppRouter />
        <SessionExpiredModal /> 
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
